import { render, staticRenderFns } from "./PatientPayments.vue?vue&type=template&id=25c8c1ce&scoped=true&"
import script from "./PatientPayments.vue?vue&type=script&lang=js&"
export * from "./PatientPayments.vue?vue&type=script&lang=js&"
import style0 from "./PatientPayments.vue?vue&type=style&index=0&id=25c8c1ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c8c1ce",
  null
  
)

export default component.exports